import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import { CaretDownIcon } from '@phosphor-icons/react/CaretDown';
import { CaretLeftIcon } from '@phosphor-icons/react/CaretLeft';
import { CaretRightIcon } from '@phosphor-icons/react/CaretRight';
import { forwardRef } from 'react';

export const PreviousIconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => (
  <IconButton ref={ref} {...props} data-test="calendar-previous-month-button">
    <CaretLeftIcon />
  </IconButton>
));
PreviousIconButton.displayName = 'PreviousIconButton';

export const NextIconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => (
  <IconButton ref={ref} {...props} data-test="calendar-next-month-button">
    <CaretRightIcon />
  </IconButton>
));
NextIconButton.displayName = 'NextIconButton';

export const SwitchViewButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => (
  <IconButton {...props} ref={ref} data-test="calendar-switch-view-button">
    <CaretDownIcon />
  </IconButton>
));
SwitchViewButton.displayName = 'SwitchViewButton';
